import { use, useState } from 'react';

import { OrganisationFormName } from '../../../../../../../domain/enums/organisation-form-name';
import OrganisationRoom from '../../../domain/organisation-room';
import ElectronicClientRecordProviderContext from '../../../providers/contexts/electronic-client-record-context';

interface LinkRoomModalHook {
  isModalOpen: boolean;
  onClose: () => void;
  handleOnLinkRoomButtonClicked: (room?: OrganisationRoom) => void;
  handleOnLinkRoomModalButtonClicked: () => void;
  isLinkRoomModalButtonDisabled: () => boolean;
}

const useLinkRoomModal = (): LinkRoomModalHook => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { watchedSelectedRoom, setSelectedTableRoom, form, loadLocations } = use(ElectronicClientRecordProviderContext);

  const onClose = (): void => {
    setSelectedTableRoom(undefined);
    setIsModalOpen(false);
  };

  const handleOnLinkRoomButtonClicked = (room?: OrganisationRoom): void => {
    if (room) {
      form.setValue(OrganisationFormName.ElectronicClientRecordRoom, room, { shouldDirty: true });
    }
    setSelectedTableRoom(undefined);
    setIsModalOpen(false);
  };

  const handleOnLinkRoomModalButtonClicked = (): void => {
    loadLocations();
    setSelectedTableRoom(undefined);
    setIsModalOpen(true);
  };

  const isLinkRoomModalButtonDisabled = (): boolean => {
    if (!watchedSelectedRoom?.id) {
      return false;
    }

    if (!watchedSelectedRoom?.isUnlinked) {
      return true;
    }

    return false;
  };

  return {
    isModalOpen,
    onClose,
    handleOnLinkRoomButtonClicked,
    handleOnLinkRoomModalButtonClicked,
    isLinkRoomModalButtonDisabled,
  };
};

export default useLinkRoomModal;
